import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { DlaService } from 'src/app/shared/dla.service';

@Component({
  selector: 'app-view-message',
  templateUrl: './view-message.component.html',
  styleUrls: ['./view-message.component.css']
})
export class ViewMessageComponent implements OnInit {
  mainPageTitle = 'View Mail';
  mail_id: string;
  type = '';
  mail: any = '';

  constructor(private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private dlaService: DlaService) { }

  ngOnInit(): void {
    this.loadScripts();

    this.mail_id = this.route.snapshot.paramMap.get('id');

    this.type = this.route.snapshot.paramMap.get('type');

    console.log('Type: ' + this.type);
    console.log('Mail ID: ' + this.mail_id);

    this.getSingleMessage();

    if (this.type === 'fro') {
      this.updateMessageStatus();
    }
  }

  updateMessageStatus() {

    this.spinner.show();
    this.dlaService.updateMessageReadStatus(this.mail_id).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          console.log(data);

        } else {
          //this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        // this.alertService.danger('An error occurred, Please try again');
      }
    );
  }

  getSingleMessage() {
    this.spinner.show();
    this.dlaService.getSingleMail(this.type, this.mail_id).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          console.log(data);
          this.mail = data;
        } else {
          this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );
  }

  loadScripts() {
    const dynamicScripts = [
      'assets/js/vendor/jquery-1.11.3.min.js',
      'assets/js/bootstrap.min.js',
      'assets/js/wow.min.js',
      'assets/js/jquery-price-slider.js',
      'assets/js/jquery.meanmenu.js',
      'assets/js/owl.carousel.min.js',
      'assets/js/jquery.sticky.js',
      'assets/js/jquery.scrollUp.min.js',
      'assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js',
      'assets/js/scrollbar/mCustomScrollbar-active.js',
      'assets/js/metisMenu/metisMenu.min.js',
      'assets/js/metisMenu/metisMenu-active.js',
      // 'assets/js/morrisjs/raphael-min.js',
      // 'assets/js/morrisjs/morris.js',
      // 'assets/js/morrisjs/morris-active.js',
      'assets/js/sparkline/jquery.sparkline.min.js',
      'assets/js/sparkline/jquery.charts-sparkline.js',
      'assets/js/calendar/moment.min.js',
      'assets/js/calendar/fullcalendar.min.js',
      'assets/js/calendar/fullcalendar-active.js',
      'assets/js/plugins.js',
      'assets/js/main.js'
    ];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

}
